import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
function Modal({
  open,
  onClose,
  title,
  children
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-163">
      {open && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-164">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="absolute inset-0 bg-black/60" onClick={onClose} data-id="element-165" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25
      }} className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto z-10" data-id="element-166">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-167">
              <h2 className="text-xl font-heading font-bold text-charcoal" data-id="element-168">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Cerrar" data-id="element-169">
                <XIcon className="w-5 h-5 text-gray-500" data-id="element-170" />
              </button>
            </div>
            <div className="px-6 py-6 text-sm font-body text-gray-700 leading-relaxed space-y-4" data-id="element-171">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}
export function SalesFooter() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer className="bg-charcoal text-gray-400 py-10 font-body" data-id="element-172">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center text-sm space-y-5" data-id="element-173">
          <p className="uppercase tracking-widest font-bold text-gray-500 text-xs" data-id="element-174">
            Aviso Legal
          </p>
          <p className="leading-relaxed" data-id="element-175">
            Este producto tiene un propósito estrictamente informativo y
            educativo. No constituye consejo médico, diagnóstico ni tratamiento
            profesional. Consulte con su médico antes de realizar cambios en su
            dieta, suplementación o rutinas de cuidado físico.
          </p>
          <div className="pt-6 border-t border-gray-700 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs" data-id="element-176">
            <p data-id="element-177">
              &copy; {new Date().getFullYear()} Protocolo SOS. Todos los
              derechos reservados.
            </p>
            <div className="flex gap-4" data-id="element-178">
              <button onClick={() => setShowTerms(true)} className="hover:text-white transition-colors cursor-pointer" data-id="element-179">
                Términos
              </button>
              <button onClick={() => setShowPrivacy(true)} className="hover:text-white transition-colors cursor-pointer" data-id="element-180">
                Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      <Modal open={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-181">
        <p className="font-bold text-charcoal" data-id="element-182">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>
        <p data-id="element-183">
          Al adquirir el producto digital "Protocolo SOS: Neuropatía y Pie
          Diabético", usted acepta los siguientes términos y condiciones:
        </p>
        <h3 className="font-heading font-bold text-charcoal text-base mt-4" data-id="element-184">
          1. Naturaleza del Producto
        </h3>
        <p data-id="element-185">
          Este es un producto digital informativo y educativo en formato eBook
          (PDF). No constituye consejo médico, diagnóstico ni tratamiento
          profesional. La información se basa en investigaciones sobre el
          cuidado del pie diabético y métodos de manejo de síntomas de
          neuropatía periférica.
        </p>
        <h3 className="font-heading font-bold text-charcoal text-base mt-4" data-id="element-186">
          2. Entrega del Producto
        </h3>
        <p data-id="element-187">
          El producto se entrega de forma digital e inmediata tras la
          confirmación del pago. Usted recibirá un enlace de descarga por correo
          electrónico. Es su responsabilidad proporcionar una dirección de
          correo electrónico válida.
        </p>
        <h3 className="font-heading font-bold text-charcoal text-base mt-4" data-id="element-188">
          3. Política de Reembolso
        </h3>
        <p data-id="element-189">
          Ofrecemos una garantía de satisfacción de 30 días. Si no está
          satisfecho con el producto por cualquier motivo, puede solicitar un
          reembolso completo dentro de los 30 días posteriores a la compra. Los
          reembolsos se procesarán dentro de 5-10 días hábiles.
        </p>
        <h3 className="font-heading font-bold text-charcoal text-base mt-4" data-id="element-190">
          4. Propiedad Intelectual
        </h3>
        <p data-id="element-191">
          Todo el contenido del eBook está protegido por derechos de autor.
          Queda prohibida la reproducción, distribución o reventa del material
          sin autorización expresa por escrito.
        </p>
        <h3 className="font-heading font-bold text-charcoal text-base mt-4" data-id="element-192">
          5. Descargo de Responsabilidad Médica
        </h3>
        <p data-id="element-193">
          El contenido no sustituye la consulta médica profesional. No ignore el
          consejo de su médico ni retrase la búsqueda de tratamiento debido a
          algo que haya leído en este producto. Antes de realizar cambios en su
          dieta, suplementación o rutinas de cuidado físico, consulte con su
          endocrinólogo o podólogo de confianza.
        </p>
        <h3 className="font-heading font-bold text-charcoal text-base mt-4" data-id="element-194">
          6. Limitación de Responsabilidad
        </h3>
        <p data-id="element-195">
          El autor y los editores no se hacen responsables de cualquier uso
          inapropiado de la información contenida en el producto. El lector
          asume toda la responsabilidad por su salud y bienestar físico. Los
          resultados pueden variar de persona a persona.
        </p>
      </Modal>

      <Modal open={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-196">
        <p className="font-bold text-charcoal" data-id="element-197">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>
        <p data-id="element-198">
          Su privacidad es importante para nosotros. Esta política describe cómo
          recopilamos, usamos y protegemos su información personal.
        </p>
        <h3 className="font-heading font-bold text-charcoal text-base mt-4" data-id="element-199">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-200">
          Recopilamos únicamente la información necesaria para procesar su
          compra: nombre, dirección de correo electrónico e información de pago.
          No almacenamos datos de tarjetas de crédito directamente; estos son
          procesados de forma segura por nuestro proveedor de pagos.
        </p>
        <h3 className="font-heading font-bold text-charcoal text-base mt-4" data-id="element-201">
          2. Uso de la Información
        </h3>
        <p data-id="element-202">
          Su información se utiliza exclusivamente para: procesar y entregar su
          compra, enviar el enlace de descarga del producto, comunicarnos con
          usted sobre su pedido, y enviar actualizaciones del producto si las
          hubiera.
        </p>
        <h3 className="font-heading font-bold text-charcoal text-base mt-4" data-id="element-203">
          3. Protección de Datos
        </h3>
        <p data-id="element-204">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger su información personal contra acceso no autorizado,
          alteración, divulgación o destrucción.
        </p>
        <h3 className="font-heading font-bold text-charcoal text-base mt-4" data-id="element-205">
          4. No Compartimos su Información
        </h3>
        <p data-id="element-206">
          No vendemos, alquilamos ni compartimos su información personal con
          terceros, excepto cuando sea necesario para procesar su pago o cuando
          lo exija la ley.
        </p>
        <h3 className="font-heading font-bold text-charcoal text-base mt-4" data-id="element-207">
          5. Cookies
        </h3>
        <p data-id="element-208">
          Nuestro sitio puede utilizar cookies para mejorar su experiencia de
          navegación y analizar el tráfico del sitio. Puede configurar su
          navegador para rechazar cookies.
        </p>
        <h3 className="font-heading font-bold text-charcoal text-base mt-4" data-id="element-209">
          6. Sus Derechos
        </h3>
        <p data-id="element-210">
          Usted tiene derecho a acceder, corregir o eliminar su información
          personal en cualquier momento. Para ejercer estos derechos,
          contáctenos a través de los canales disponibles en nuestro sitio.
        </p>
      </Modal>
    </>;
}